<a
  *transloco="let t; prefix: scope"
  class="flex h-full min-h-44 flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-steel-30 bg-white px-2 py-4 text-center font-normal text-steel-70 no-underline!"
  routerLink="/search"
>
  <rma-icon glyph="add_circle_outline" theme="inactive" />
  <span class="text-xs md:text-sm">{{ t('cardsRow.addAgents') }}</span>
</a>
